import { HIDE_SIDEBAR, SHOW_SIDEBAR, TOOGLE_SIDEBAR, SET_HEADER_TITLE } from "../constants";

const initialState = {
  isSideBar: false,
  headerTitle: ''
};

const layoutReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case SHOW_SIDEBAR:
      return {
        ...state,
        isSideBar: true,
      };
    case HIDE_SIDEBAR:
      return {
        ...state,
        isSideBar: false,
      };
    case SET_HEADER_TITLE:
      return {
        ...state,
        headerTitle: action.payload,
      };
    case TOOGLE_SIDEBAR:
      return {
        ...state,
        isSideBar: !state.isSideBar,
      };
    default:
      return state;
  }
};

export default layoutReducer;
